import React, { FunctionComponent } from 'react';
import { sanitizeHtml } from '../../utils/text';
import { Text } from '@wix/design-system';
type RenderHTMLProps = {
  html: string;
  className?: string;
  dataHook?: string;
  textElement?: React.ComponentProps<typeof Text>;
};

export const RenderHTML: FunctionComponent<RenderHTMLProps> = ({
  html,
  className,
  dataHook,
  textElement,
}: RenderHTMLProps) =>
  textElement ? (
    <Text
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
      dataHook={dataHook}
      {...textElement}
    />
  ) : (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
      data-hook={dataHook}
    />
  );
